export const SET_HRES6LU_INDEX_DISP = 'SET_HRES6LU_INDEX_DISP'
export const GET_HRES6LU_INDEX_DISP = 'GET_HRES6LU_INDEX_DISP'
export const SET_HRES6LU_DETAIL_DISP = 'SET_HRES6LU_DETAIL_DISP'
export const GET_HRES6LU_DETAIL_DISP = 'GET_HRES6LU_DETAIL_DISP'
export const GET_HRES6LU_MAX_ROWSPAN = 'GET_HRES6LU_MAX_ROWSPAN'
export const SET_HRES6LU_COLUMNS = 'SET_HRES6LU_COLUMNS'
export const GET_HRES6LU_COLUMNS = 'GET_HRES6LU_COLUMNS'
export const SET_HRES6LU_LABELS = 'SET_HRES6LU_LABELS'
export const GET_HRES6LU_LABELS = 'GET_HRES6LU_LABELS'
export const RECEIVED_HRES6LU_COLUMNS_LABELS = 'RECEIVED_HRES6LU_COLUMNS_LABELS'
export const SET_HRES6LU_INDEX = 'SET_HRES6LU_INDEX'
export const GET_HRES6LU_INDEX = 'GET_HRES6LU_INDEX'
export const RECEIVED_HRES6LU_INDEX = 'RECEIVED_HRES6LU_INDEX'
export const SET_HRES6LU_INDEX_SELECTED = 'SET_HRES6LU_INDEX_SELECTED'
export const GET_HRES6LU_INDEX_SELECTED = 'GET_HRES6LU_INDEX_SELECTED'
export const SET_HRES6LU_DETAIL = 'SET_HRES6LU_DETAIL'
export const GET_HRES6LU_DETAIL = 'GET_HRES6LU_DETAIL'
export const RECEIVED_HRES6LU_DETAIL = 'RECEIVED_HRES6LU_DETAIL'
export const TOGGLE_HRES6LU_PAGE = 'TOGGLE_HRES6LU_PAGE'
export const POST_HRES6LU_SEND_APPROVE = 'POST_HRES6LU_SEND_APPROVE'



// WEBPACK FOOTER //
// ./src/store/modules/hres6lu/mutation-types.js